import axiosInstance from "../../../axios";

export const getWebinarService = async (payload) => {
  try {
    console.log("oho", payload);

    const response = await axiosInstance.get(
      `/webinars?limit=${payload.currentPageLimit}&page=${
        payload.currentPage
      }&search=${
        payload.searchKey === "" ? payload.searchKeyAdvanced : payload.searchKey
      }&category=${payload.category}&speaker=${payload.speaker}&date=${
        payload.date
      }&recordingAvailable=${payload.recordingAvailable}&web=${payload.web || " "}`
    );
    console.log(response, "ohio");
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

export const deleteWebinarService = async (id) => {
  try {
    console.log("oho", id);
    const response = await axiosInstance.delete(`/webinars/${id}`);
    console.log(response, "ohio");
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

export const getCategoryService = async (id) => {
  try {
    console.log("oho", id);
    const response = await axiosInstance.get(`/webinars/category`);
    console.log(response, "ohio");
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

export const SendInvitationService = async (payload) => {
  try {
    const response = await axiosInstance.post(`team/send-invitation`, payload);
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

export const updateWebinar = async (id, payload) => {
  try {
    const { data } = await axiosInstance.patch(`webinars/${id}`, payload);
    return data;
  } catch (error) {
    return {error: e?.response?.message}
  }
};
